module.exports = __webpack_public_path__ + "img/drive-buzz-full-logo.85f3902a.png";